import { AnyAction, combineReducers, configureStore, Reducer } from '@reduxjs/toolkit';
import { useDispatch } from 'react-redux';
import { persistReducer } from 'redux-persist';
import localForage from 'localforage'
import thunk from 'redux-thunk';
import globalReducer from '../shared/global-store/global.slice';
import authReducer from '../pages/utillity-pages/login/store/auth.slice';
import workingEfficiencyReducer from '../pages/efficiencies/efficiency/store/workingEfficiency.slice';
import movementEfficiencyReducer from '../pages/efficiencies/efficiency/store/movementEfficiency.slice';
import usageEfficiencyReducer from '../pages/efficiencies/efficiency/store/usageEfficiency.slice';
import loadEfficiencyReducer from '../pages/efficiencies/efficiency/store/loadEfficiency.slice';
import adminViewReducer from '../pages/admin-pages/admin-view/store/admin-view.slice';
import realTimeMapViewReducer from '../pages/efficiencies/real-time-map-view/store/real-time-map-view.slice';
import compareEfficiencySlice from '../pages/efficiencies/comparision-analysis/store/comparision-analysis.slice';
import heatmapSlice from '../pages/efficiencies/heatmap/store/heatmap.slice';
import efficiencySummarySlice from '../pages/efficiencies/efficiency-summary/store/efficiency-summary.slice';
import efficiencySummaryV2Slice from '../pages/efficiencies/efficiency-summary-v2/store/efficiency-summary.slice';
import operatorAnalysisSlice from '../pages/operators/operator-analysis/store/operator-analysis.slice';
import operatorComparingSlice from '../pages/operators/operator-comparing/store/operator-comparing.slice';
import alarmSlice from '../pages/alarms/alarm-table/store/alarm.slice';
import alarmReportSlice from '../pages/alarms/alarm-report/store/alarm-reports.slice';
import alarmSetsSlice from '../pages/alarms/alarm-sets/store/alarm-sets.slice';
import indoorManagementSlice from '../pages/admin-pages/indoor-management/store/indoor-management.slice';
import venueManagementSlice from '../pages/admin-pages/venue-management/store/venue-management.slice';
import userSettingsSlice from '../pages/utillity-pages/user-settings/store/user-settings.slice';
import dashboardSlice from '../pages/utillity-pages/dashboard/store/dashboard.slice';
import dashboardLayoutSlice from '../pages/utillity-pages/dashboard/store/dashboard-layout.slice';
import workingHoursSlice from '../pages/working-hours/store/working-hours.slice';
import aiAssistantReducer from '../pages/ai-assistant/store/ai-assistant.slice';
import OperatorListSlice from '../pages/operators/operator-list/store/operator-list.slice';
import dailyEfficiencySummarySlice from '../pages/efficiencies/daily-efficiency-summary/store/daily-efficiency-summary.slice';
import unauthorizedUsageSlice from '../pages/operators/unauthorized-usage/store/unauthorized-usage.slice';
import maintenanceLogSettingsReducer from '../pages/maintenance-logs/store/maintenance-log-settings.slice';
import aiReportsReducer from '../pages/ai-assistant/ai-reports/store/ai-reports.slice';
import safetySettingsReducer from '../pages/safety/store/safety-settings.slice';
import advancedFilterPresetsReducer from '../shared/components/advanced-filter/store/advanced-filter-presets.slice';
import indoorMapsReducer from '../pages/indoor-maps/store/indoor-maps.slice';
import indoorAnalyticsReducer from '../pages/indoor-maps/store/indoor-analytics.slice';
export const PersistanceStoreName = 'mevzu-admin';
const reducers = combineReducers({
    globalState: globalReducer,
    authState: authReducer,
    workingEfficiencyState: workingEfficiencyReducer,
    movementEfficiencyState: movementEfficiencyReducer,
    usageEfficiencyState: usageEfficiencyReducer,
    loadEfficiencyState: loadEfficiencyReducer,
    adminViewState: adminViewReducer,
    realTimeMapViewState: realTimeMapViewReducer,
    compareEfficiencyState: compareEfficiencySlice,
    heatmapState: heatmapSlice,
    efficiencySummaryState: efficiencySummarySlice,
    efficiencySummaryV2State: efficiencySummaryV2Slice,
    operatorAnalysisState: operatorAnalysisSlice,
    operatorComparingState: operatorComparingSlice,
    alarmTableState: alarmSlice,
    alarmReportsState: alarmReportSlice,
    alarmSetsState: alarmSetsSlice,
    indoorManagementState: indoorManagementSlice,
    venueManagementState: venueManagementSlice,
    userSettingsState: userSettingsSlice,
    dashboardState: dashboardSlice,
    dashboardLayoutState: dashboardLayoutSlice,
    workingHoursState: workingHoursSlice,
    aiAssistant: aiAssistantReducer,
    operatorListState: OperatorListSlice,
    dailyEfficiencySummaryState: dailyEfficiencySummarySlice,
    unauthorizedUsageState: unauthorizedUsageSlice,
    maintenanceLogSettings: maintenanceLogSettingsReducer,
    aiReportsState: aiReportsReducer,
    safetySettings: safetySettingsReducer,
    advancedFilterPresets: advancedFilterPresetsReducer,
    indoorMapsState: indoorMapsReducer,
    indoorAnalyticsState: indoorAnalyticsReducer
});
const rootReducer: Reducer = (state: RootState, action: AnyAction) => {
    if (action.type === 'USER_LOGOUT') {
        return reducers(undefined, action);
    }
    return reducers(state, action);
};

const persistConfig = {
    key: PersistanceStoreName,
    storage: localForage,
    blacklist: ['aiAssistant', 'aiReportsState', 'indoorAnalyticsState']
};

const persistedReducer = persistReducer(persistConfig, rootReducer)

const store = configureStore({
    reducer: persistedReducer,
    devTools: true,
    middleware: [thunk]
});

export default store;
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export const useAppDispatch = () => useDispatch<AppDispatch>()